// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvailableReports {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.AvailableReports-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.AvailableReports-tooltip svg {
  width: 16px !important;
  height: 16px !important;
}
.AvailableReports-text {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  color: #2b2b2b;
  color: var(--color_neutral_900, #2b2b2b);
  font-size: 14px;
  font-weight: 700;
}
.AvailableReports-text-reports {
  color: #6224c6;
  color: var(--color_primary_500, #6224c6);
}
.AvailableReports-text-reports-notEnough {
  color: #9ba1ad;
  color: var(--color_neutral_500, #9ba1ad);
}
.AvailableReports-text-renewal {
  color: #9ba1ad;
  color: var(--color_neutral_500, #9ba1ad);
  font-size: 12px;
  font-weight: 400;
}
.AvailableReports-loadingWrapper {
  height: 40px;
}
.AvailableReports-loadingWrapper-notEnough {
  height: 117px;
}`, "",{"version":3,"sources":["webpack://./src/components/GenerateWinninAIReportModal/components/AvailableReports/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACJ;AAGI;EACE,sBAAA;EACA,uBAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EAEA,cAAA;EAAA,wCAAA;EACA,eAAA;EACA,gBAAA;AAJJ;AAMI;EACE,cAAA;EAAA,wCAAA;AAJN;AAMM;EACE,cAAA;EAAA,wCAAA;AAJR;AASE;EACE,cAAA;EAAA,wCAAA;EACA,eAAA;EACA,gBAAA;AAPJ;AAUE;EACE,YAAA;AARJ;AAUI;EACE,aAAA;AARN","sourcesContent":[".AvailableReports {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  &-content {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &-tooltip {\n    svg {\n      width: 16px !important;\n      height: 16px !important;\n    }\n  }\n\n  &-text {\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    align-items: center;\n\n    color: var(--color_neutral_900, #2b2b2b);\n    font-size: 14px;\n    font-weight: 700;\n\n    &-reports {\n      color: var(--color_primary_500, #6224c6);\n\n      &-notEnough {\n        color: var(--color_neutral_500, #9ba1ad);\n      }\n    }\n  }\n\n  &-text-renewal {\n    color: var(--color_neutral_500, #9ba1ad);\n    font-size: 12px;\n    font-weight: 400;\n  }\n\n  &-loadingWrapper {\n    height: 40px;\n\n    &-notEnough {\n      height: 117px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
